module.exports = __webpack_public_path__ + "img/facturacion.7698b587.jpg";